import { AuthSessionVerdict } from '@hooks/useAuthSessionProbe';

export enum AuthPhase {
  INITIALIZING = 'initializing',
  AUTHENTICATED = 'authenticated',
  UNAUTHENTICATED = 'unauthenticated',
  SESSION_LOST = 'sessionLost',
  LOGGING_OUT = 'loggingOut',
  EMAIL_UNVERIFIED = 'emailUnverified'
}

export interface DeriveAuthPhaseInputs {
  isLoading: boolean;
  isAuthenticated: boolean;
  hasAccountMe: boolean;
  probeVerdict: AuthSessionVerdict;
  loggingOut: boolean;
  sessionInvalid: boolean;
  emailUnverified: boolean;
}

// Precedence (first match wins):
// LOGGING_OUT -> EMAIL_UNVERIFIED -> INITIALIZING(loading) -> SESSION_LOST ->
// INITIALIZING(probing/profile) -> AUTHENTICATED -> UNAUTHENTICATED
export function deriveAuthPhase(inputs: DeriveAuthPhaseInputs): AuthPhase {
  const {
    isLoading,
    isAuthenticated,
    hasAccountMe,
    probeVerdict,
    loggingOut,
    sessionInvalid,
    emailUnverified
  } = inputs;

  const authenticatedWithProfile = isAuthenticated && hasAccountMe;

  if (loggingOut) return AuthPhase.LOGGING_OUT;
  if (emailUnverified) return AuthPhase.EMAIL_UNVERIFIED;
  if (isLoading) return AuthPhase.INITIALIZING;
  if (isAuthenticated && sessionInvalid) return AuthPhase.SESSION_LOST;
  if (probeVerdict === AuthSessionVerdict.SESSION_LOST) return AuthPhase.SESSION_LOST;
  if (!authenticatedWithProfile && probeVerdict === AuthSessionVerdict.PROBING)
    return AuthPhase.INITIALIZING;
  if (isAuthenticated && !hasAccountMe) return AuthPhase.INITIALIZING;
  if (authenticatedWithProfile) return AuthPhase.AUTHENTICATED;
  if (probeVerdict === AuthSessionVerdict.NO_SESSION) return AuthPhase.UNAUTHENTICATED;
  return AuthPhase.INITIALIZING;
}
